import dayjs from 'dayjs'
import { TimeRange } from 'features/systemLens'
import {
  BaseSensorEntry,
  ChartTimeUnit,
  TimeSeriesDerivedValueEntryJSON,
} from 'types'

/**
 * Returns a default time range of the last 7 days with 15-minute intervals
 */
export function getDefaultTimeRange(): TimeRange {
  const now = dayjs()
  const past = dayjs().subtract(7, 'day')

  return {
    from: past.toISOString(),
    to: now.toISOString(),
    preset: 'last-7-days',
    interval: 15,
    intervalUnit: ChartTimeUnit.MINUTES,
  }
}

/**
 * Helper function to get all active items (sensors + derived values with dependencies met)
 */
export function getAllActiveItems(
  selectedSensors: BaseSensorEntry[],
  derivedValues: TimeSeriesDerivedValueEntryJSON[]
): Array<{ id: string; name?: string }> {
  const allItems: Array<{ id: string; name?: string }> = selectedSensors.map(
    (sensor) => ({
      id: sensor.id,
      name: sensor.data.name,
    })
  )

  // Add derived values that have all dependencies selected
  derivedValues.forEach((derived) => {
    const allDependenciesSelected = derived.data.dependencyIds.every(
      (sensorId) => selectedSensors.some((selected) => selected.id === sensorId)
    )

    if (allDependenciesSelected) {
      allItems.push({
        id: derived.id,
        name: derived.data.name,
      })
    }
  })

  return allItems
}
